// Controls the launch splash that index.html paints before the bundle runs.
import { useEffect } from 'react';

/** Long enough for the wordmark and wave to finish drawing. */
export const SPLASH_MIN_MS = 2300;
const FADE_MS = 550;

type SplashWindow = Window & { __obvSplashT0?: number; __obvAppStarted?: boolean };

export function markAppStarted() {
  (window as SplashWindow).__obvAppStarted = true;
}

/** Fades the splash out once it has played; `now` skips the wait (an error must be visible). */
export function hideSplash(now = false) {
  const el = document.getElementById('splash');
  if (!el || el.getAttribute('data-hiding')) return;
  el.setAttribute('data-hiding', '1');
  const t0 = (window as SplashWindow).__obvSplashT0 || 0;
  const wait = now ? 0 : Math.max(0, SPLASH_MIN_MS - (Date.now() - t0));
  setTimeout(() => {
    el.className += ' out';
    setTimeout(() => {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, FADE_MS);
  }, wait);
}

/** Shows a status line under the wordmark while the splash is still up. */
export function setSplashMessage(text: string) {
  const msg = document.getElementById('splash-msg');
  if (msg) msg.textContent = text;
}

/** Call from the first screen with real content. */
export function useHideSplash() {
  useEffect(() => hideSplash(), []);
}
